import Container from './LogoutOauthPage.container';
import LogoutOauthPage from './LogoutOauthPage';

export default Container(LogoutOauthPage);
